/** Removes the static splash painted by the HTML shell once real content (or an error) is on screen. */
export function hideBootSplash(): void {
  document.getElementById('boot')?.remove();
  try {
    // The page came up: let the shell's watchdog self-heal again if a later visit gets stuck.
    sessionStorage.removeItem('boot-heal');
  } catch {
    /* storage unavailable */
  }
}
